import {
    IMPORTER_BILLS_QUEUE,
    IMPORTER_INVOICES_QUEUE,
} from "@common/helpers/financialDocument";
import { FileType } from "@common/constants/financial-documents";

export type AccrualDocumentImporterMode = "invoices" | "bills";

export const ACCRUAL_DOCUMENT_FILE_TYPES: readonly FileType[] = [
    FileType.PDF,
    FileType.JPG,
    FileType.JPEG,
    FileType.PNG,
];

export const ACCRUAL_DOCUMENT_FILE_TYPES_NAMES = "PDFs and images";

interface AccrualDocumentImporterModeConfig {
    importerQueue: string;
    modalTitle: string;
    counterpartyColumnHeader: string;
    uploadDropzoneLabel: string;
    uploadMenuItemLabel: string;
}

const MODE_CONFIG: Record<
    AccrualDocumentImporterMode,
    AccrualDocumentImporterModeConfig
> = {
    invoices: {
        importerQueue: IMPORTER_INVOICES_QUEUE,
        modalTitle: "Import invoices",
        counterpartyColumnHeader: "Customer",
        uploadDropzoneLabel: "Upload or drop in invoices",
        uploadMenuItemLabel: "Upload invoice",
    },
    bills: {
        importerQueue: IMPORTER_BILLS_QUEUE,
        modalTitle: "Import bills",
        counterpartyColumnHeader: "Vendor",
        uploadDropzoneLabel: "Upload or drop in bills",
        uploadMenuItemLabel: "Upload bill",
    },
};

export function getAccrualDocumentImporterConfig(
    mode: AccrualDocumentImporterMode,
): AccrualDocumentImporterModeConfig {
    return MODE_CONFIG[mode];
}
